import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/lib/firebase/config';
import * as authService from '@/lib/firebase/auth';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return {
    user,
    loading,
    signInWithEmail: authService.signInWithEmail,
    signInWithGoogle: authService.signInWithGoogle,
    registerWithEmail: authService.registerWithEmail,
    logOut: authService.logOut,
    sendPasswordReset: authService.sendPasswordReset,
    getCurrentUser: authService.getCurrentUser
  };
}; 